import * as React from 'react'
import Accordion from '../sharedComponents/Accordion'
import { IDownloadAccordionContent } from '../models'
import { animationFadeInUp } from '../constants'
import { useEffect } from 'react'
import { PdfIcon } from '../icons/pdfIcon'

function DownloadAccordion({
  content,
}: {
  content: IDownloadAccordionContent
}) {
  const onDownload = (e, url, target) => {
    e.preventDefault()
    if (url) window.open(url, target || '_self')
  }

  useEffect(() => {
    window.animationRefresh()
  }, [])

  return (
    <div>
      {content.Items.map((item) => (
        <div className={`${animationFadeInUp}`}>
          <Accordion
            headline={`${item.Title} ${
              item.Files ? '(' + item.Files.length + ')' : ''
            }`}
          >
            <div>
              {item.Files?.length &&
                item.Files?.map((download) => (
                  <div
                    className="flex justify-between md:items-center px-container  py-6 border-b-separator flex-col md:flex-row gap-4 md:gap-0"
                    key={download.Name}
                  >
                    <div className="flex gap-3 items-center ">
                      <PdfIcon />
                      <span>
                        <b>{download.Name}</b>
                      </span>
                    </div>
                    <div>
                      <button
                        className="btn btn-secondary "
                        onClick={(e) =>
                          onDownload(e, download.Url, download.Target)
                        }
                      >
                        {content.DownloadButtonLabel}
                      </button>
                    </div>
                  </div>
                ))}
            </div>

            {item.Text && (
              <div className="px-container py-4 md:py-6 xl:py-10 flex justify-between flex-col md:flex-row">
                <div className=" rte-accordion max-w-[579px]">
                  <div
                    className="rte-container"
                    dangerouslySetInnerHTML={{
                      __html: JSON.parse(`"${item.Text}"`),
                    }}
                  ></div>

                {item.AudioFile && (
                  <div className="">
                    <audio controls controlsList="nodownload">
                    <source
                          src={`${item.AudioFile?.Url}`}
                          type="audio/mpeg"
                        />
                    </audio>
                  </div>
                )}

                </div>

                {item.File && (
                  <div className="">
                    <button
                      className="btn btn-secondary "
                      onClick={(e) =>
                        onDownload(e, item.File?.Url, item.File?.Target)
                      }
                    >
                      {content.DownloadButtonLabel} {item.File.Name}
                    </button>
                  </div>
                )}

                {item.PresentationFile && (
                  <div className="">
                    <button
                      className="btn btn-secondary "
                      onClick={(e) =>
                        onDownload(e, item.PresentationFile?.Url, item.PresentationFile?.Target)
                      }
                    >
                      {content.DownloadButtonLabel} {item.PresentationFile.Name}
                    </button>
                  </div>
                )}
              </div>
            )}
          </Accordion>
        </div>
      ))}
    </div>
  )
}

export default DownloadAccordion
